export var IncomeOrExpenseType;
(function (IncomeOrExpenseType) {
    IncomeOrExpenseType["Income"] = "income";
    IncomeOrExpenseType["Expense"] = "expense";
})(IncomeOrExpenseType || (IncomeOrExpenseType = {}));
export var IncomeOrExpenseApportionmentMode;
(function (IncomeOrExpenseApportionmentMode) {
    IncomeOrExpenseApportionmentMode["Single"] = "single";
    IncomeOrExpenseApportionmentMode["Multiple"] = "multiple";
})(IncomeOrExpenseApportionmentMode || (IncomeOrExpenseApportionmentMode = {}));
export var IncomeType;
(function (IncomeType) {
    IncomeType["DepositInterestIncome"] = "depositInterestIncome";
    IncomeType["DividendIncome"] = "dividendIncome";
    IncomeType["InterestIncome"] = "interestIncome";
    IncomeType["InterestOutsideOfCarryIncome"] = "interestOutsideOfCarryIncome";
    IncomeType["OtherIncome"] = "otherIncome";
    IncomeType["OtherOutsideOfCarryIncome"] = "otherOutsideOfCarryIncome";
    IncomeType["AccruedIncome"] = "accruedIncome";
})(IncomeType || (IncomeType = {}));
export var ExpenseType;
(function (ExpenseType) {
    ExpenseType["AccountingFeeExpense"] = "accountingFeeExpense";
    ExpenseType["AdministrationFeeExpense"] = "administrationFeeExpense";
    ExpenseType["AdvisoryFeeExpense"] = "advisoryFeeExpense";
    ExpenseType["AifmFeeExpense"] = "aifmFeeExpense";
    ExpenseType["AuditFeeExpense"] = "auditFeeExpense";
    ExpenseType["BankCharges"] = "bankCharges";
    ExpenseType["ConsultancyFeeExpense"] = "consultancyFeeExpense";
    ExpenseType["CustodianFeeExpense"] = "custodianFeeExpense";
    ExpenseType["DepositoryFeeExpense"] = "depositoryFeeExpense";
    ExpenseType["DirectorsFeeExpense"] = "directorsFeeExpense";
    ExpenseType["IncentiveFeeExpense"] = "incentiveFeeExpense";
    ExpenseType["InformationTechnologyExpense"] = "informationTechnologyExpense";
    ExpenseType["InsuranceExpense"] = "insuranceExpense";
    ExpenseType["OtherExpense"] = "otherExpense";
    ExpenseType["LegalAndProfessionalFeesExpense"] = "legalAndProfessionalFeesExpense";
    ExpenseType["ManagementFee"] = "managementFee";
    ExpenseType["OperatingExpense"] = "operatingExpense";
    ExpenseType["OperationAndMaintenanceExpense"] = "operationAndMaintenanceExpense";
    ExpenseType["OrganisationExpense"] = "organisationExpense";
    ExpenseType["PlacementFeeExpense"] = "placementFeeExpense";
    ExpenseType["RegulatoryAndTaxFee"] = "regulatoryAndTaxFee";
    ExpenseType["ReimbursementFeeExpense"] = "reimbursementFeeExpense";
    ExpenseType["SecretarialFeeExpense"] = "secretarialFeeExpense";
    ExpenseType["SundryExpense"] = "sundryExpense";
    ExpenseType["TaxationExpense"] = "taxationExpense";
    ExpenseType["TravelAndEntertainmentExpense"] = "travelAndEntertainmentExpense";
    ExpenseType["InterestExpense"] = "interestExpense";
    ExpenseType["AccruedExpense"] = "accruedExpense";
})(ExpenseType || (ExpenseType = {}));
export var IncomeOrExpenseState;
(function (IncomeOrExpenseState) {
    IncomeOrExpenseState["Payable"] = "payable";
    IncomeOrExpenseState["Receivable"] = "receivable";
    IncomeOrExpenseState["Accrued"] = "accrued";
})(IncomeOrExpenseState || (IncomeOrExpenseState = {}));
export var CustomIncomeOrExpenseType;
(function (CustomIncomeOrExpenseType) {
    CustomIncomeOrExpenseType["CustomActionType"] = "customActionType";
})(CustomIncomeOrExpenseType || (CustomIncomeOrExpenseType = {}));
export var IncomeOrExpenseTransactionSubType;
(function (IncomeOrExpenseTransactionSubType) {
    IncomeOrExpenseTransactionSubType["AccruedIncomeDebit"] = "accruedIncomeDebit";
    IncomeOrExpenseTransactionSubType["AccruedIncomeCredit"] = "accruedIncomeCredit";
    IncomeOrExpenseTransactionSubType["AccruedExpenseDebit"] = "accruedExpenseDebit";
    IncomeOrExpenseTransactionSubType["AccruedExpenseCredit"] = "accruedExpenseCredit";
})(IncomeOrExpenseTransactionSubType || (IncomeOrExpenseTransactionSubType = {}));
//# sourceMappingURL=index.js.map